class LogoSlider {
    constructor() {
        this.DOM = {
            block: document.querySelector('.logo-slider')
        };

        if (!this.DOM.block) {
            return;
        }

        this.DOM.wrapperContainer = this.DOM.block.querySelector('.logo-wrappers');

        if (!this.DOM.wrapperContainer) {
            return;
        }

        this.initSlider();
    }

    initSlider() {
        const mainWrapper = this.DOM.wrapperContainer.querySelector('.logo-wrapper');
        if (!mainWrapper) {
            return;
        }

        //duplicate the main wrapper to create a seamless loop
        const cloneWrapper = mainWrapper.cloneNode(true);
        cloneWrapper.ariaHidden = true;
        cloneWrapper.classList.add('logo-wrapper-clone');
        this.DOM.wrapperContainer.appendChild(cloneWrapper);
        // add it 2 times to the dom to make sure the loop is seamless

        const cloneWrapper2 = mainWrapper.cloneNode(true);
        cloneWrapper2.ariaHidden = true;
        cloneWrapper2.classList.add('logo-wrapper-clone');
        this.DOM.wrapperContainer.appendChild(cloneWrapper2);
    }
}
window.LogoSlider = new LogoSlider();
